import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={13.828}
    height={25.701}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 6187 11500"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="XMLID_5_">
        <path
          d="M6187 10620c-158 261-468 726-734 726-8 0-16 0-24-1-158-16-276-189-400-371-150-220-319-469-615-480h-16c-292 0-466 250-633 491-178 256-345 498-639 514-367 20-710-184-821-249-226-135-350-277-449-391-119-137-231-265-445-268-289 0-463 245-616 461-108 152-220 310-329 311-50 0-176-102-466-768 712-665 1195-1709 1523-2774h3134c333 1074 821 2129 1530 2799zM4566 7512H1613c185-658 311-1311 399-1873h2146c90 561 221 1214 408 1873zM4111 5329H2057c77-551 113-985 128-1203h1790c17 218 56 651 136 1203zM2925 0h309v3817h-309z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
